import { viewedCounts } from "./viewedlayers.js";

// What the legend should show.
// A historic analysis takes priority over the current one.
export const buildLegend = ({ impacts, viewed, realPolygon, simPolygon }) => {
  if (viewed?.data) {
    const c = viewedCounts(viewed.data);
    return {
      showAreas: false,
      results: {
        buildings: {
          sinistre: { count: c.burned },
          preserve: { count: c.saved },
        },
      },
    };
  }
  if (impacts?.data?.results) {
    return {
      showAreas: true,
      results: impacts.data.results,
      realArea: realPolygon.area,
      simArea: simPolygon.area,
    };
  }
  return null;
};
